var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('div',{class:_vm.menuClasses},[(_vm.isOpen)?_c('div',{staticClass:"offcanvas-overlay"}):_vm._e(),_c('div',{staticClass:"offcanvas-content"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }